import { GalleryCardWrapper } from "./GalleryCardWrapper";
import React from "react";
import { formatSessionNameForURL } from "../v2_actions/nav";
import { useGalleryFilterSearchParams } from "./hooks/useGalleryFilterSearchParams";
import { useNavigate } from "react-router-dom";

export const GalleryEventCard = ({ image, title, gallery_event_name, tab }) => {
  const navigate = useNavigate();
  const [, , searchParams] = useGalleryFilterSearchParams();

  const onSelectedGalleryEvent = () => {
    window.open(
      `/customer/events/${formatSessionNameForURL(gallery_event_name)}`,
      '_blank'
    )
  };

  return (
    <>
      <GalleryCardWrapper
        tab={tab}
        title={title}
        image={image}
        onClick={onSelectedGalleryEvent}
        cardType={"gallery-event"}
      />
    </>
  );
};
